// get min and max Y values for the graph range, with addition of 20%
import { swSettings } from "app/common/services/swSettings";
import { abbrNumberVisitsFilter } from "app/filters/ngFilters";

const USER_ACTIVITY_IOS = "AppEngagementUserActivityIOS";

export const getIsNewEngagementIosMetrics = () =>
    swSettings.components[USER_ACTIVITY_IOS]?.resources?.IsNewEngagementIosMetrics || false;

export function getNumberFilter() {
    return (num) => {
        if (num === null || num === undefined || num === 0) {
            return "0";
        }
        return abbrNumberVisitsFilter()(num);
    };
}

export const getHasPremiumPlusClaim = () => swSettings?.user?.hasAppsPremiumPlus;
